import React, { ReactNode } from 'react';
import { Card } from './Card';
import { Diff } from '../Diff';
import { getDiff, getComparePresetLabel } from '../../model/Diff';
import { ComparePreset } from '../../model/datePicker/types';
import { Information } from '../Information';

const ValueCard = ({ title, value, previousValue, format, color, icon, informationId, comparePreset }: Props) => {
  return (
    <Card className={`card-border-shadow-${color}`}>
      <div className="card-body">
        <div className="d-flex align-items-center">
          {icon}
          <h4 className="flex-grow-1 ms-3 mb-0">{format ? format(value) : value}</h4>
        </div>
        <div className="d-flex align-items-center mt-3 mb-2">
          <Information id={informationId} content={<span>{title}</span>} />
          <Information id={informationId} showMore={true} className="ms-2" />
        </div>
        <small className="d-flex align-items-center">
          <Diff value={getDiff(value, previousValue)} />
          <div className="text-muted">{getComparePresetLabel(comparePreset)} ({format ? format(previousValue) : previousValue})</div>
        </small>
      </div>
    </Card>);
}

interface Props {
  title: string,
  value: number,
  previousValue: number,
  color: string,
  format?: (value: number) => string,
  icon: ReactNode,
  informationId: string,
  comparePreset?: ComparePreset
}

export { ValueCard };
